/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum AdminUserType {
    OWNER = 'owner',
    EMPLOYEE = 'employee',
    READ_ONLY = 'read_only',
}